// ValidacionCarnet — página PÚBLICA (sin sesión) que abre el QR del carnet: confirma si el carnet es
// válido. Muestra lo mínimo: titular, documento enmascarado, cooperativa, número y vigencia.

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { CheckCircle as OkIcon, Cancel as NoIcon } from '@mui/icons-material';
import { afiliacionApi } from '../services/coopnetApi';
import { fecha } from '../utils/formato';

const Fila = ({ titulo, valor }) => (valor ? (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="caption" color="text.secondary">{titulo}</Typography>
    <Typography variant="body1" fontWeight={600}>{valor}</Typography>
  </Box>
) : null);

export default function ValidacionCarnet() {
  const { codigo } = useParams();
  const [estado, setEstado] = useState({ cargando: true, r: null, error: '' });

  useEffect(() => {
    let vivo = true;
    afiliacionApi
      .validarCarnet(codigo)
      .then((r) => vivo && setEstado({ cargando: false, r, error: '' }))
      .catch((e) => {
        if (!vivo) return;
        // 404: el código no existe → la respuesta trae { valido:false, mensaje }
        if (e.status === 404) setEstado({ cargando: false, r: e.body || { valido: false, mensaje: 'Carnet no encontrado.' }, error: '' });
        else setEstado({ cargando: false, r: null, error: 'No se pudo verificar el carnet. Intenta de nuevo en unos minutos.' });
      });
    return () => { vivo = false; };
  }, [codigo]);

  const { cargando, r, error } = estado;
  const color = r?.valido ? '#2E7D32' : '#C62828';

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f4f6f4', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Card sx={{ maxWidth: 440, width: '100%', borderTop: `8px solid ${cargando ? '#9e9e9e' : color}` }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="overline" color="text.secondary">Verificación de carnet</Typography>
          {cargando ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}><CircularProgress /></Box>
          ) : error ? (
            <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>
          ) : (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, my: 2 }}>
                {r?.valido ? <OkIcon sx={{ fontSize: 48, color }} /> : <NoIcon sx={{ fontSize: 48, color }} />}
                <Typography variant="h5" fontWeight={800} sx={{ color }}>{r?.mensaje || (r?.valido ? 'Carnet vigente' : 'Carnet no válido')}</Typography>
              </Box>
              <Fila titulo="Titular" valor={r?.titular} />
              <Fila titulo="Documento" valor={r?.documento} />
              <Fila titulo="Cooperativa" valor={r?.cooperativa} />
              <Fila titulo="N.º de registro" valor={r?.numeroRegistro} />
              <Fila titulo="Vigente hasta" valor={r?.fechaVigencia ? fecha(r.fechaVigencia) : ''} />
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
